import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import SVGViewer from '../../../commonUI/SVGViewer';
import orientationDiagram1 from './svgs/OrientationDiagram1.svg';
import orientationDiagram2 from './svgs/OrientationDiagram2.svg';

const StyledBox = styled(Box)({
  width: '100%',
  padding: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
});

const OrientationFormTabDiagramSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: (theme) => theme.borderRadius.primary,
        width: '260px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        p: '1rem',
      }}
    >
      <StyledBox>
        <Typography variant='h6'>{t('Example 1', { ns: 'common' })}</Typography>
        <SVGViewer svg={orientationDiagram1} alt='Orientation Example 1' />
      </StyledBox>
      <StyledBox>
        <Typography variant='h6'>{t('Example 2', { ns: 'common' })}</Typography>
        <SVGViewer svg={orientationDiagram2} alt='Orientation Example 2' />
      </StyledBox>
    </Box>
  );
};

export default OrientationFormTabDiagramSection;
